import { render } from "./GenericTableScrollable.vue?vue&type=template&id=453a8f32&scoped=true"
import script from "./GenericTableScrollable.vue?vue&type=script&lang=js"
export * from "./GenericTableScrollable.vue?vue&type=script&lang=js"

import "./GenericTableScrollable.vue?vue&type=style&index=0&id=453a8f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453a8f32"]])

export default __exports__